import { render, staticRenderFns } from "./ProgramPayment.vue?vue&type=template&id=d97547c4&scoped=true"
import script from "./ProgramPayment.vue?vue&type=script&lang=js"
export * from "./ProgramPayment.vue?vue&type=script&lang=js"
import style0 from "./ProgramPayment.vue?vue&type=style&index=0&id=d97547c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97547c4",
  null
  
)

export default component.exports